import GraphicOverviewSubPage from "./graphic-owerview-sub-page";
import GraphicRulesSubPage from "./graphic-rules-sub-page";

const SubPage = {
  OverView: GraphicOverviewSubPage,
  Rules: GraphicRulesSubPage,
};

export default SubPage;
